import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { Button, FormGroup, Label, Input } from "reactstrap";
import Play from "../../../assets/images/verboden/play.png";
import Gameoption from "../../../assets/images/tot/game-option.png";
import Alert from "../../../components/shared/common/alert";
import * as loaderAction from "../../../redux/loader/action";
import Socket from "../../../socket/socket";
import * as paramsAction from "../../../redux/gameParams/actions";
import sfw_switch_circle from "../../../assets/images/CHPT/sfw-switch.png";
// import timed_game_switch from "../../../assets/images/bingo/timed_game_switch.png";

const TotGameOption = (props) => {
  const status = _.get(props, "gameReducer.roomObj.game_state.status");
  // const [gameTitle, setGameTitle] = useState(
  //   props.gameReducer.allGames[3].title || ""
  // );
  const [gameTitle, setGameTitle] = useState(
    props?.gameReducer?.gamesData?.onboarding?.step_3?.games[3]?.label || ""
  );

  const { toggle_how_to_play_modal } = props;

  useEffect(() => {
    return Socket.addListener("update-status", async (res) => {
      props.history.push({
        pathname: "/tot"
      });
      props.setIsLoading(false);
    });
  }, []);


//game option changes as per new edditions i.e global and home
  const gameOptions = _.get(
    params,
    "lobby.game_options_label",
    "Game Options"
  );

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/tot");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const onStartGame = () => {
    const roomData = props.gameReducer.roomObj;
    if (roomData && roomData.users && roomData.users.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    }
    let obj = {
      action: "update-status",
      roomId: roomData.id,
      tableTopName: "TIP OF THE TONGUE",
      // tableTopName: gameTitle || props.gameReducer.allGames[3].title,
      timer: parseInt(props.timer),
      doubleRounds: props.isDoubleRounds
      // ["category": category]
    };
    Socket.sendMessage(obj);
  };

  const { paramsReducer } = props;
  const params = _.get(paramsReducer, "gameObj.screens", {}) || {};
  const gameOptionsLabel = _.get(
    params,
    "lobby.game_options_label",
    "Game Options"
  );
  const gameNameLabel = _.get(params, "lobby.game_name_label");
  const timerLabel = _.get(params, "lobby.timer_label");
  const timerLabel1 = _.get(params, "lobby.timer_label_1");
  const timerLabel2 = _.get(params, "lobby.timer_label_2");
  const timerLabel3 = _.get(params, "lobby.timer_label_3");
  const timer_1 = _.get(params, "lobby.timer_1");
  const timer_2 = _.get(params, "lobby.timer_2");
  const timer_3 = _.get(params, "lobby.timer_3");
  const doubleRoundsLabel = _.get(
    params,
    "lobby.double_rounds_label",
    "Double Rounds"
  );
  const startBtnText = _.get(params, "lobby.button_text", "START");
  let timer_for_mapping = _.get(
    props.gameReducer,
    "roomObj.lobby_parameters.timer"
  );

  const handleChange = (e) => {
    setGameTitle(e.target.value);
  };
  return (
    <>
      <div className="game-options-wrapper">
        {/* <div className="tot-game-title">{gameOptionsLabel}</div> */}
        <div className="tot-game-title">
          <img src={Gameoption}></img>
        </div>
        <div className="game-options-timer">
          <div className="totTimer-wrapper">
            <h4 className="text-orange">{timerLabel}</h4>
            <div className="totTimer-radioBtn">
              <FormGroup check>
                <Label check className="text">
                  <Input
                    type="radio"
                    name="radio2"
                    checked={timer_1 == timer_for_mapping}
                    value={timer_1}
                    onClick={(e) => props.onTimerChange(e.target.value)}
                  />{" "}
                  <span className="radioBtn"></span>
                  {timerLabel1}
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="text">
                  <Input
                    type="radio"
                    name="radio2"
                    checked={timer_2 == timer_for_mapping}
                    value={timer_2}
                    onClick={(e) => props.onTimerChange(e.target.value)}
                  />{" "}
                  <span className="radioBtn"></span>
                  {timerLabel2}
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="text">
                  <Input
                    type="radio"
                    name="radio2"
                    checked={timer_3 == timer_for_mapping}
                    value={timer_3}
                    onClick={(e) => props.onTimerChange(e.target.value)}
                  />{" "}
                  <span className="radioBtn"></span>
                  {timerLabel3}
                </Label>
              </FormGroup>
            </div>
          </div>
          <div className="tot-toggle-wrapper">
            <h4 className="text-orange">{doubleRoundsLabel}</h4>
            <div className="tot-on-off-toggle">
              <label className="switch">
                {/* <input
                  checked={props.isDoubleRounds}
                  type="checkbox"
                  className="tot-checkbox"
                  onChange={(e) => props.onDoubleRoundsChange(e.target.checked)}
                /> */}
                {/* <span className="slider round">
                  <span className="text"></span>
                </span> */}
                {props.isDoubleRoundsForMapp ? (
                  <span
                    name="on"
                    class="on"
                    onClick={() =>
                      props.onDoubleRoundsChange(!props.isDoubleRounds)
                    }
                  >
                    <img
                      src={sfw_switch_circle}
                      alt="on"
                      className="on-img"
                    ></img>
                    <span className="on-text">ON</span>
                  </span>
                ) : (
                  <span
                    name="off"
                    class="off"
                    onClick={() =>
                      props.onDoubleRoundsChange(!props.isDoubleRounds)
                    }
                  >
                    <img
                      src={sfw_switch_circle}
                      alt="on"
                      className="off-img"
                    ></img>
                    OFF
                  </span>
                )}
              </label>
            </div>
          </div>
        </div>
        <div>
          <Button
            color="themePink"
            className="how-to-play-btn"
            onClick={toggle_how_to_play_modal}
          >
            HOW TO PLAY
          </Button>
        </div>
      </div>
      <div className="play-btn mt-3 text-center">
        <Button onClick={() => onStartGame()} color="totthemeGreen">
          {startBtnText}
          <img src={Play} className="mr-2" />
        </Button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TotGameOption);
